export function singleBtnFunc() {
    var wpBtn;
    wpBtn =".wpBtn";
    if($(wpBtn).length){
        $(wpBtn).append('<object class="objAnime" type="image/svg+xml" data="/images/svg/icon_white_long_arrow.svg"></object>');
    }
}